import i18n, {TFunction} from 'i18next';

import {ProductOperation} from 'core/dictionaries';

interface Dictionary<Value> {
    [id: string]: Value;
}

export const mapDictionaryToOptions = (dictionary: Dictionary<string>) =>
    Object.keys(dictionary).map((el: string) => ({label: dictionary[el], value: el}));

export const mapEnumToI18nOptions = (list: any, scope: string) =>
    Object.keys(list).map((el: string) => ({label: i18n.t(`${scope}.${el}`), value: el}));

export const mapArrayToI18nOptions = (list: {key: any; value: any}[], scope: string) =>
    list.map((item) => ({label: i18n.t(`${scope}.${item.key}`), value: item.value}));

export const mapValueIfKeyExist = (path: string, value: string) => {
    const result = path + value;
    return i18n.exists(result) ? result : value;
};

const OPERATION_REASON_I18N_SCOPE: Partial<Record<ProductOperation, string>> = {
    [ProductOperation.BLOCKED]: 'dictionaries.products.blockingReason',
    [ProductOperation.UNBLOCKED]: 'dictionaries.products.unblockingReason',
    [ProductOperation.DROPOUT]: 'dictionaries.documents.DropOut.reasons',
    [ProductOperation.REPLACED_BY_REMARKING]: 'dictionaries.documents.remarking.reasons',
    [ProductOperation.CREATED_BY_REMARKING]: 'dictionaries.documents.remarking.reasons',
    [ProductOperation.RETURNED_BY_CONSUMER]: 'dictionaries.documents.returnGoods.reasons',
    [ProductOperation.RETURNED]: 'dictionaries.documents.returnGoods.reasons',
};

export const translateOperationReason = (
    operationAction: ProductOperation,
    reason: string,
    t: TFunction,
) => {
    const scope = OPERATION_REASON_I18N_SCOPE[operationAction];
    if (!scope) return reason;

    const key = `${scope}.${reason}`;

    return i18n.exists(key) ? String(t(key)) : reason;
};

export const mapStorageTypesToI18nOptions = (list: number[], scope: string) =>
    list.map((el: number) => ({label: i18n.t(`${scope}.${el}.label`), value: el}));

export const yearsOptions = (first = 2020, last = new Date().getFullYear()) => {
    let current = first;
    const list: number[] = [];

    while (current <= last) {
        list.push(current);
        current++;
    }

    return list.map((y) => ({label: y, value: y}));
};
